<template>
  <el-dialog custom-class="mini-dialog" title="二次发货" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">

      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="物流公司" :label-width="formLabelWidth" prop="logisticsco">
            <el-select v-model="form.logisticsco" placeholder="请选择" style="width: 135px;">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="快递单号" :label-width="formLabelWidth" prop="logisticsnum">
            <el-input v-model="form.logisticsnum" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getParameterDetail} from '@/api/set/parameter';
  import {ispsq, ercifahuo} from '@/api/set/csagreement';

  export default {
    name: "aaa",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        form: {
          unitguid: '',//表单数据
          logisticsco: '',
          logisticsnum: ''
        },
        erpserial:'',
        parameterData: [],
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          logisticsco: [
            {required: true, message: '请选择物理公司', trigger: 'blur'},
          ],
        },
      }
    },
    methods: {

      show(unitguid, customerserial,erpserial) {
        this.initForm();
        this.form.unitguid = unitguid
        this.erpserial=erpserial
        ispsq({customerserial: customerserial}).then(response => {
          if (response.data.obj <= 0) {
            for (let i in this.parameterData) {
              if (this.parameterData[i].name == '配送') {
                this.parameterData.splice(i, 1)
              }
            }
          }
        })
        this.dialogFormVisible = true;
      },
      saveData() {
        if (this.form.logisticsco != '配送' && this.form.logisticsco != '自取') {
          if (!this.form.logisticsnum) {
            this.$message({
              message: '请输入物流单号',
              type: 'error',
              duration: 1500,
            })
            return
          }
        }
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.dialogFormVisible = false;
            this.form.logisticsnum=this.form.logisticsnum.trim()
            ercifahuo(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.$emit('bindGrid');
                this.dialogFormVisible = false;
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            })
          }
        });
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
      }
    },
    mounted() {
      getParameterDetail({paraname: "快递公司"}).then(response => {
        this.parameterData = JSON.parse(response.data.obj.paracontent);
        this.form.logisticsco = this.parameterData[0].name
      })
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/TwoShipmentsEdit.vue